module.exports = __webpack_public_path__ + "static/media/juice.8bba1fa5.webp";